
<div mat-dialog-content class="text-center">
    {{data}}
</div>

<div *ngIf="isMamSncf() === false" class="row justify-content-center mt-3" >
    <button mat-stroked-button class="activebtn" color="primary"   tabindex="-1"  (click)="onConfirm()">Ok</button>
</div>


<div *ngIf="isMamSncf() === true" class="row justify-content-center mt-3" >
    <button mat-stroked-button class="mamsncf_buton" color="primary"   tabindex="-1"  (click)="onConfirm()">Ok</button>
</div>
  
  